import type { Direction } from "../direction";
import { deserializeXY } from "../serialization";
import { SolidifierShot } from "./solidifierShot";

export class ShortSolidifierShot extends SolidifierShot {
	static key = "ShortSolidifierShot";

	getMaxRange(): number {
		return 2;
	}

	static deserialize(data: any): ShortSolidifierShot {
		const shot = new ShortSolidifierShot(deserializeXY(data.xy), data.direction as Direction);
		shot.visualId = data.visualId;
		shot.travelledDistance = data.travelledDistance;
		return shot;
	}
}
